(function () {
  var FEED_SECTION = 'pd26-media-feed';
  var LOG = '[pd26-media]';

  function debug() {
    var args = [LOG].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function debugWarn() {
    var args = [LOG].concat(Array.prototype.slice.call(arguments));
    console.warn.apply(console, args);
  }

  function bindSticky(toolbar) {
    if (!toolbar || toolbar.getAttribute('data-pd26-media-sticky') === 'true') return;
    toolbar.setAttribute('data-pd26-media-sticky', 'true');

    var placeholder = document.createElement('div');
    placeholder.className = 'pd26-media-hero__toolbar-placeholder';
    placeholder.hidden = true;
    toolbar.parentNode.insertBefore(placeholder, toolbar);

    function sync() {
      var pinTop = placeholder.hidden
        ? toolbar.getBoundingClientRect().top
        : placeholder.getBoundingClientRect().top;

      if (pinTop <= 0) {
        if (!toolbar.classList.contains('is-fixed')) {
          placeholder.style.height = toolbar.offsetHeight + 'px';
          placeholder.hidden = false;
          toolbar.classList.add('is-fixed');
        }
      } else if (toolbar.classList.contains('is-fixed')) {
        toolbar.classList.remove('is-fixed');
        placeholder.hidden = true;
        placeholder.style.height = '';
      }
    }

    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function bindTop(button) {
    if (!button || button.getAttribute('data-pd26-media-top') === 'true') return;
    button.setAttribute('data-pd26-media-top', 'true');
    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function listSectionId(list) {
    var wrapper = list.closest('.shopify-section');
    if (!wrapper || !wrapper.id) return '';
    return wrapper.id.replace(/^shopify-section-/, '');
  }

  function feedRequestUrl(pageUrl, sectionId, useView) {
    var url = new URL(pageUrl, window.location.origin);
    var current = new URL(window.location.href);
    ['preview_theme_id', 'preview_theme_token', '_ab', '_fd', 'pb'].forEach(function (key) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    });
    if (useView) url.searchParams.set('view', 'pd26-media');
    url.searchParams.set('sections', sectionId);
    return url.pathname + url.search;
  }

  function nextRequest(list) {
    list._pd26MediaRequest = (list._pd26MediaRequest || 0) + 1;
    return list._pd26MediaRequest;
  }

  function ensureSnapshot(list) {
    if (list._pd26MediaSnapshot) return;
    var items = list.querySelector('.pd26-media-list__items');
    var pager = list.querySelector('.pd26-media-pager');
    list._pd26MediaSnapshot = {
      items: items ? items.innerHTML : '',
      pager: pager ? pager.innerHTML : '',
      pagerHidden: !pager || pager.hasAttribute('hidden')
    };
  }

  function setPager(list, html, hidden) {
    var pager = list.querySelector('.pd26-media-pager');
    if (!pager) return;
    pager.innerHTML = html || '';
    if (hidden) pager.setAttribute('hidden', '');
    else pager.removeAttribute('hidden');
  }

  function showMessage(list, message) {
    var items = list.querySelector('.pd26-media-list__items');
    if (items) items.innerHTML = '<p class="pd26-media-empty"></p>';
    var empty = items && items.querySelector('.pd26-media-empty');
    if (empty) empty.textContent = message;
    setPager(list, '', true);
  }

  function applyLearnMore(list) {
    var label = list.getAttribute('data-learn-more') || 'Learn More';
    list.querySelectorAll('.pd26-media-card__more').forEach(function (node) {
      node.textContent = label;
    });
  }

  function restore(list) {
    ensureSnapshot(list);
    var snapshot = list._pd26MediaSnapshot;
    var items = list.querySelector('.pd26-media-list__items');
    if (items) items.innerHTML = snapshot.items;
    setPager(list, snapshot.pager, snapshot.pagerHidden);
  }

  function showAll(list) {
    nextRequest(list);
    list.removeAttribute('aria-busy');
    if (/[?&]page=/.test(window.location.search)) {
      window.location.assign(window.location.pathname);
      return;
    }
    restore(list);
  }

  function readFeedHtml(data, sectionId) {
    if (!data) return '';
    if (data[sectionId]) return data[sectionId];
    var keys = Object.keys(data);
    for (var i = 0; i < keys.length; i += 1) {
      if (data[keys[i]]) return data[keys[i]];
    }
    return '';
  }

  function loadFeed(list, pageUrl) {
    var requestId = nextRequest(list);
    var sectionId = listSectionId(list) || FEED_SECTION;
    var useView = sectionId === FEED_SECTION;
    var requestUrl = feedRequestUrl(pageUrl, sectionId, useView);
    ensureSnapshot(list);
    list.setAttribute('aria-busy', 'true');
    debug('blog title', {
      heroTitle: (document.querySelector('[data-pd26-media-hero]') || {}).getAttribute
        ? document.querySelector('[data-pd26-media-hero]').getAttribute('data-blog-title') || ''
        : '',
      listTitle: list.getAttribute('data-blog-title') || '',
      sectionId: sectionId
    });
    debug('fetch feed', { requestId: requestId, pageUrl: pageUrl, requestUrl: requestUrl, sectionId: sectionId });

    fetch(requestUrl, {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        debug('feed response', { requestId: requestId, status: res.status, contentType: res.headers.get('content-type') });
        return res.text().then(function (text) {
          if (!res.ok) {
            debugWarn('feed HTTP error', { status: res.status, body: text.slice(0, 500) });
            throw new Error('feed failed');
          }
          try {
            return JSON.parse(text);
          } catch (error) {
            debugWarn('feed response is not JSON', { body: text.slice(0, 500) });
            throw error;
          }
        });
      })
      .then(function (data) {
        if (requestId !== list._pd26MediaRequest) {
          debug('ignore stale feed response', { requestId: requestId, current: list._pd26MediaRequest });
          return;
        }
        var html = readFeedHtml(data, sectionId);
        debug('feed JSON keys', data ? Object.keys(data) : [], {
          sectionId: sectionId,
          hasSectionHtml: !!html,
          htmlLength: html ? html.length : 0,
          sectionValue: data && data[sectionId] === null ? null : typeof (data && data[sectionId])
        });
        if (!html) {
          debugWarn('section HTML missing', { expectedKey: sectionId, keys: data ? Object.keys(data) : [] });
          showMessage(list, 'No articles found.');
          return;
        }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextItems = doc.querySelector('.pd26-media-list__items');
        var nextPager = doc.querySelector('.pd26-media-pager');
        var nextList = doc.querySelector('[data-pd26-media-list]');
        var items = list.querySelector('.pd26-media-list__items');
        debug('parsed feed', {
          blogTitle: nextList ? nextList.getAttribute('data-blog-title') || '' : '',
          cards: nextItems ? nextItems.querySelectorAll('.pd26-media-card').length : 0,
          hasItems: !!nextItems,
          hasPager: !!nextPager,
          pagerHidden: !nextPager || nextPager.hasAttribute('hidden')
        });
        if (!items || !nextItems) {
          debugWarn('cannot replace list', { hasPageItems: !!items, hasFeedItems: !!nextItems });
          showMessage(list, 'No articles found.');
          return;
        }
        items.innerHTML = nextItems.innerHTML;
        setPager(list, nextPager ? nextPager.innerHTML : '', !nextPager || nextPager.hasAttribute('hidden'));
        applyLearnMore(list);
        debug('list updated', { blogTitle: nextList ? nextList.getAttribute('data-blog-title') || '' : '' });
      })
      .catch(function (error) {
        debugWarn('feed request failed', error);
        if (requestId !== list._pd26MediaRequest) return;
        showMessage(list, 'No articles found.');
      })
      .finally(function () {
        if (requestId === list._pd26MediaRequest) list.removeAttribute('aria-busy');
      });
  }

  function setActiveTab(hero, button) {
    hero.querySelectorAll('[data-pd26-media-tag]').forEach(function (tab) {
      tab.classList.toggle('is-active', tab === button);
    });
  }

  function bindList(list) {
    if (!list || list.getAttribute('data-pd26-media-ready') === 'true') return;
    list.setAttribute('data-pd26-media-ready', 'true');
    ensureSnapshot(list);
    debug('list ready', { id: list.id, learnMore: list.getAttribute('data-learn-more') });
  }

  function bindHero(hero) {
    if (!hero || hero.getAttribute('data-pd26-media-filter') === 'true') {
      debug('hero bind skipped', { hasHero: !!hero, alreadyBound: !!(hero && hero.getAttribute('data-pd26-media-filter') === 'true') });
      return;
    }
    hero.setAttribute('data-pd26-media-filter', 'true');

    var buttons = hero.querySelectorAll('[data-pd26-media-tag]');
    debug('hero ready', {
      id: hero.id,
      blogTitle: hero.getAttribute('data-blog-title') || '',
      blogUrl: hero.getAttribute('data-blog-url') || '',
      tags: Array.prototype.map.call(buttons, function (button) {
        return button.getAttribute('data-pd26-media-tag') || '(All)';
      })
    });

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var list = document.querySelector('[data-pd26-media-list]');
        var tag = button.getAttribute('data-pd26-media-tag') || '';
        var blogUrl = hero.getAttribute('data-blog-url') || '';
        debug('tag click', {
          label: (button.textContent || '').trim(),
          tag: tag || '(All)',
          blogTitle: hero.getAttribute('data-blog-title') || '',
          listBlogTitle: list ? list.getAttribute('data-blog-title') || '' : '',
          blogUrl: blogUrl,
          hasList: !!list,
          listCount: document.querySelectorAll('[data-pd26-media-list]').length
        });
        if (!list) {
          debugWarn('click ignored: page has no PD26 Media List');
          return;
        }
        setActiveTab(hero, button);
        if (!tag) {
          debug('show all articles');
          showAll(list);
          return;
        }
        if (!blogUrl) {
          debugWarn('click ignored: Media Hero Blog setting is empty');
          nextRequest(list);
          list.removeAttribute('aria-busy');
          showMessage(list, 'Select the same blog on Media Hero and Media List.');
          return;
        }
        loadFeed(list, blogUrl.replace(/\/$/, '') + '/tagged/' + encodeURIComponent(tag));
      });
    });
  }

  function bindFeedPager() {
    if (document.documentElement.getAttribute('data-pd26-media-pager') === 'true') return;
    document.documentElement.setAttribute('data-pd26-media-pager', 'true');
    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-pd26-media-feed-url]');
      if (!link) return;
      var list = link.closest('[data-pd26-media-list]');
      if (!list) return;
      event.preventDefault();
      loadFeed(list, link.getAttribute('data-pd26-media-feed-url'));
    });
  }

  function init(scope) {
    var root = scope || document;
    debug('init', {
      heroes: root.querySelectorAll('[data-pd26-media-hero]').length,
      lists: root.querySelectorAll('[data-pd26-media-list]').length,
      pageHeroes: document.querySelectorAll('[data-pd26-media-hero]').length,
      pageLists: document.querySelectorAll('[data-pd26-media-list]').length
    });
    root.querySelectorAll('[data-pd26-media-toolbar]').forEach(bindSticky);
    root.querySelectorAll('[data-pd26-media-top]').forEach(bindTop);
    root.querySelectorAll('[data-pd26-media-list]').forEach(bindList);
    root.querySelectorAll('[data-pd26-media-hero]').forEach(bindHero);
    if (root.hasAttribute && root.hasAttribute('data-pd26-media-toolbar')) bindSticky(root);
    if (root.hasAttribute && root.hasAttribute('data-pd26-media-top')) bindTop(root);
    if (root.hasAttribute && root.hasAttribute('data-pd26-media-list')) bindList(root);
    if (root.hasAttribute && root.hasAttribute('data-pd26-media-hero')) bindHero(root);
    bindFeedPager();
  }

  debug('script loaded');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
